import { useState } from 'react'
import { Mail, X } from 'lucide-react'
import { useAppSelector } from '../hooks/useAppStore'
import { selectCurrentUser } from '../store/slices/authSlice'
import EmailVerificationModal from './EmailVerificationModal'

export default function EmailVerificationBanner() {
    const user = useAppSelector(selectCurrentUser)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isDismissed, setIsDismissed] = useState(false)

    // Don't show banner if user is null, email is verified, or banner is dismissed
    if (!user || user.isEmailVerified || isDismissed) {
        return null
    }

    return (
        <>
            <div className='bg-gradient-to-r from-[#FF6B35] to-[#FF8C61] text-white px-4 py-3 shadow-sm'>
                <div className='container mx-auto flex items-center justify-between gap-4'>
                    <div className='flex items-center gap-3 flex-1'>
                        <div className='bg-white/20 p-2 rounded-lg'>
                            <Mail className='w-5 h-5' />
                        </div>
                        <div className='flex-1'>
                            <p className='font-medium text-sm md:text-base'>
                                Verify your email address
                            </p>
                            <p className='text-xs md:text-sm text-white/90'>
                                Please verify your email to ensure you receive important notifications
                            </p>
                        </div>
                    </div>

                    <div className='flex items-center gap-2'>
                        <button
                            onClick={() => setIsModalOpen(true)}
                            className='bg-white text-[#FF6B35] px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-100 transition-colors whitespace-nowrap'
                        >
                            Verify Now
                        </button>
                        <button
                            onClick={() => setIsDismissed(true)}
                            className='p-2 hover:bg-white/10 rounded-lg transition-colors'
                            aria-label='Dismiss'
                        >
                            <X className='w-5 h-5' />
                        </button>
                    </div>
                </div>
            </div>

            <EmailVerificationModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                userEmail={user.email}
            />
        </>
    )
}
